import React from 'react';

const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-soft-blue via-white to-soft-blue">
      {/* pt-24 clears the fixed header, matching About/FAQ. */}
      <div className="max-w-4xl mx-auto px-4 pt-24 pb-16">
        <h1 className="text-4xl font-bold text-karvlo-navy mb-8">Terms of Service</h1>
        <p className="text-karvlo-gray mb-6">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

        <div className="space-y-8 text-karvlo-gray leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold text-karvlo-navy mb-3">1. Acceptance of Terms</h2>
            <p>By accessing or using Karvlo's ride-hailing platform, you agree to be bound by these Terms of Service. If you do not agree, please do not use our services.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-karvlo-navy mb-3">2. Service Description</h2>
            <p>Karvlo provides a technology platform that connects riders with drivers in Hong Kong. We are not a transportation company; we facilitate connections between independent drivers and riders.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-karvlo-navy mb-3">3. Account Requirements</h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>You must be at least 18 years old to create an account</li>
              <li>You must provide accurate and complete registration information</li>
              <li>You are responsible for maintaining the security of your account</li>
              <li>One account per person — duplicate accounts may be terminated</li>
              <li>Drivers must have a valid Hong Kong driving license and appropriate insurance</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-karvlo-navy mb-3">4. Rider Terms</h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>You agree to pay the fare shown at the time of booking plus any applicable surcharges</li>
              <li>Cancellation fees apply as per our cancellation policy</li>
              <li>You must treat drivers with respect and follow safety guidelines</li>
              <li>Damage to a driver's vehicle may result in additional charges</li>
              <li>You must be present at the pickup location at the agreed time</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-karvlo-navy mb-3">5. Driver Terms</h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>Drivers must maintain valid vehicle registration, insurance, and HKID</li>
              <li>Vehicles must be in safe, roadworthy condition</li>
              <li>Drivers must follow all applicable traffic laws</li>
              <li>Drivers are independent contractors, not employees of Karvlo</li>
              <li>Driver accounts require approval and verification before activation</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-karvlo-navy mb-3">6. Pricing & Payments</h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>Fares are calculated based on base fare, distance, and time</li>
              <li>Three vehicle tiers: Economy (from HK$19), Comfort (from HK$28), Premium (from HK$40)</li>
              <li>Surge pricing may apply during high-demand periods</li>
              <li>Payments are processed securely through Stripe</li>
              <li>Driver payouts are available via bank transfer, PayPal, or USDC</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-karvlo-navy mb-3">7. Cancellation Policy</h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>Free cancellation within 2 minutes of booking</li>
              <li>HK$15 fee for cancellation after 2 minutes</li>
              <li>HK$25 fee plus waiting charges if driver has arrived at pickup</li>
              <li>Safety-related cancellations are always free</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-karvlo-navy mb-3">8. Prohibited Conduct</h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>Harassment, discrimination, or threatening behavior</li>
              <li>Using the service for illegal purposes</li>
              <li>Creating fake accounts or manipulating ratings</li>
              <li>Transporting illegal substances or weapons</li>
              <li>Sharing account credentials with others</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-karvlo-navy mb-3">9. Safety</h2>
            <p>We provide emergency SOS features, ride sharing capabilities, and driver verification to promote safety. However, riders and drivers use the platform at their own risk. Report safety concerns immediately to <a href="mailto:safety@karvlo.com" className="text-karvlo-blue hover:underline">safety@karvlo.com</a>.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-karvlo-navy mb-3">10. Limitation of Liability</h2>
            <p>Karvlo provides the platform "as is" during the beta period. We are not liable for delays, route deviations, or issues between riders and drivers beyond reasonable dispute resolution.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-karvlo-navy mb-3">11. Account Termination</h2>
            <p>We reserve the right to suspend or terminate accounts that violate these terms. You may delete your account at any time through your profile settings, which will anonymize your personal data.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-karvlo-navy mb-3">12. Governing Law</h2>
            <p>These terms are governed by the laws of Hong Kong SAR. Any disputes shall be resolved through the courts of Hong Kong.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-karvlo-navy mb-3">13. Contact</h2>
            <p>Questions about these terms? Contact us at <a href="mailto:legal@karvlo.com" className="text-karvlo-blue hover:underline">legal@karvlo.com</a> or <a href="mailto:support@karvlo.com" className="text-karvlo-blue hover:underline">support@karvlo.com</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
